import {
    ADDITIONAL_PAGE_OPTIONS,
    SalesChannel,
} from '@vfde-sails/constants';

/**
 * Get sales channel from additional page options
 *
 * The TOP doesn't read the sales channel from storage or URL, because that would lock the customer within a sales channel without any chance to switch it.
 * It still stores the sales channel in storage though, for use by other applications.
 */
export const getSalesChannel = (): SalesChannel => window[ADDITIONAL_PAGE_OPTIONS].salesChannel;
